const footNav = [
  {
    title: "玩法",
    links: ["一键去水印", "链接解析", "倍速播放", "高清录屏", "弹幕聚合", "全局聚合"],
  },
  {
    title: "入口",
    links: ["玩法总览", "玩法快讯", "今日热榜", "操作指南", "妙用场景", "常见问题"],
  },
  {
    title: "使用",
    links: ["新手看这里", "直播补课攻略", "二创素材整理", "精品收藏归档", "常见 Q&A"],
  },
];

const anchors = ["#play", "#flash", "#rank", "#guide", "#scene", "#faq"];

export default function Footer() {
  return (
    <footer>
      {/* CTA 号召带 */}
      <div
        className="relative overflow-hidden bg-primary-600 text-background-50"
        style={{
          background:
            "linear-gradient(115deg, oklch(var(--primary-700)), oklch(var(--accent-600)) 62%, oklch(var(--accent-500)))",
        }}
      >
        <div className="pointer-events-none absolute -right-10 -top-16 h-56 w-56 rounded-full bg-background-50/10 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-16 -left-8 h-56 w-56 rounded-full bg-background-50/10 blur-2xl" />
        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-5 px-4 py-10 md:flex-row md:items-center md:px-6 md:py-14">
          <div>
            <p className="font-heading text-2xl font-black md:text-3xl">
              去水印解析、倍速录屏、弹幕聚合
              <br className="hidden md:block" />
              一套玩法，把「吃瓜」吃明白
            </p>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-50/85">
              本篇为吃瓜神器玩法专题合集首页，只做功能演示与玩法整理，不含任何接口、登录与真实提交。想系统上手，就从上面的操作指南开始。
            </p>
          </div>
          <a
            href="#play"
            className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-transform hover:-translate-y-0.5"
          >
            <i className="ri-arrow-up-line" />
            回到玩法总览
          </a>
        </div>
      </div>

      {/* 浅色运营页脚 */}
      <div className="bg-background-200">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-8 px-4 py-10 md:grid-cols-5 md:px-6 md:py-14">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-base" />
              </span>
              <span className="whitespace-nowrap font-heading text-lg font-bold text-foreground-950">
                吃瓜神器
              </span>
            </div>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600">
              去水印、解析、倍速、录屏、弹幕、聚合六大玩法的专题合集指南，帮你把每一场视频与直播热闹都吃到位。
            </p>
            <div className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800">
              <i className="ri-water-flash-line" />
              吃瓜神器 · 玩法合集指南
            </div>
          </div>

          {footNav.map((col, ci) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-3 flex flex-col gap-2">
                {col.links.map((l, li) => {
                  const href = anchors[li % anchors.length] ?? "#top";
                  return (
                    <li key={l}>
                      <a
                        href={href}
                        className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                      >
                        {l}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-300">
          <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
            <p className="whitespace-nowrap">© 2026 吃瓜神器 · 玩法专题合集演示页</p>
            <p className="whitespace-nowrap">本页为吃瓜神器玩法指南，仅作功能演示</p>
          </div>
        </div>
      </div>
    </footer>
  );
}